{
  "page": {
    "title": "Team"
  },
  "members": {
    "title": "Team members",
    "empty": "No team members yet",
    "owner": "Owner",
    "admin": "Admin",
    "unknown": "Unknown",
    "thisMember": "this member",
    "extraPermissions": "{{count}} extra permissions",
    "managePermissions": "Manage permissions",
    "remove": "Remove",
    "removeTitle": "Remove team member",
    "removeDetail": "Remove {{name}} from the team? They will lose access to this store, but can be invited again later.",
    "removeButton": "Remove member",
    "removeSuccess": "Team member removed.",
    "removeFailed": "Could not remove the team member.",
    "cancel": "Cancel"
  },
  "invitations": {
    "title": "Invitations",
    "pending": "Pending",
    "accepted": "Accepted",
    "revoked": "Revoked",
    "expired": "Expired",
    "sendSuccess": "Invitation sent.",
    "sendFailed": "Could not send the invitation.",
    "revokeSuccess": "Invitation cancelled.",
    "revokeFailed": "Could not cancel the invitation.",
    "copied": "Invitation link copied.",
    "copyFailed": "Could not copy the link. Please copy it manually.",
    "planExpired": "Your plan has expired. Subscribe before inviting a member.",
    "seatsFull": "All seats on your plan are in use.",
    "seatsUsed": "{{used}} / {{total}} seats used",
    "addSeats": "Add seats",
    "inviteAdmin": "Invite admin",
    "empty": "No pending invitations",
    "copyLink": "Copy link",
    "cancel": "Cancel",
    "send": "Send invitation",
    "email": "Email"
  },
  "permissions": {
    "title": "Manage permissions for {{name}}",
    "member": "member",
    "close": "Close",
    "roleBase": "Included with the Admin role",
    "updateFailed": "Could not update permissions.",
    "manageProducts": {
      "label": "Manage products",
      "description": "Add, edit, and remove products and stock"
    },
    "manageOrders": {
      "label": "Manage orders",
      "description": "View and update customer order statuses"
    },
    "connectPlatform": {
      "label": "Connect channels",
      "description": "Connect LINE, Facebook, and Instagram and configure channels"
    },
    "inviteAdmin": {
      "label": "Invite and manage admins",
      "description": "Invite members, cancel invitations, and manage other admins' permissions"
    },
    "manageBilling": {
      "label": "View plan and manage billing",
      "description": "View plans, purchase a plan, and review payment history"
    },
    "manageAiBot": {
      "label": "Configure AI assistant",
      "description": "Enable or disable the bot and configure its messages, channels, and payment settings"
    }
  },
  "invitePage": {
    "emailMismatch": "Your email does not match this invitation.",
    "userHasMerchant": "You already belong to a store and cannot accept this invitation.",
    "notFound": "This invitation was not found or has expired.",
    "genericError": "Something went wrong. Please try again.",
    "success": "You joined the team!",
    "invited": "You've been invited",
    "signInPrompt": "Sign in or register with the invited email address",
    "joinTeamPrompt": "to join the team.",
    "login": "Sign in",
    "register": "Register",
    "redirecting": "Taking you to the dashboard...",
    "joinMerchant": "Join {{name}}",
    "team": "team",
    "acceptTitle": "Accept invitation",
    "invitedBy": "{{name}} invited you as {{role}}",
    "admin": "an admin",
    "joinInvitation": "You've been invited to join the team.",
    "accept": "Accept invitation"
  },
  "errors": {
    "selfInvite": "You cannot invite yourself.",
    "teamFull": "The team is full.",
    "seatCap": "All seats are in use. Upgrade your plan or add seats.",
    "subscriptionExpired": "Your plan has expired. Subscribe before inviting members.",
    "tooManyPending": "There are too many pending invitations.",
    "duplicate": "An invitation has already been sent to this email.",
    "userHasMerchant": "This user already belongs to a store.",
    "cooldown": "Please wait before sending another invitation.",
    "generic": "Something went wrong. Please try again."
  }
}
